export default __webpack_public_path__ + "static/media/x2y2.969348d4.svg";